<div class="heading py-5">
  <h1 class="bold font-curve-large">Datatable</h1>
  <h2 class="font-curve-medium">Using ngx-datatable 20.0.0</h2>
  <a
    href="https://swimlane.gitbook.io/ngx-datatable/"
    target="_blank"
    rel="noopener"
    class="btn btn-primary btn-sm btn-animated"
  >
    <span>Ngx-datatable documentation</span>
  </a>
  &nbsp;
  <a
    href="http://swimlane.github.io/ngx-datatable/"
    target="_blank"
    rel="noopener"
    class="btn btn-primary btn-sm btn-animated"
  >
    <span>Ngx-datatable demos</span>
  </a>
</div>

<div class="alert alert-warning mb-bigger-big" role="alert">
  <h4 class="alert-heading">Ngx-datatable is not fully accessible</h4>
  <p>
    The datatable offered by the ngx-datatable package does not meet the required accessibility
    standards, therefore it should be avoided in Internet applications.
  </p>
</div>

<section>
  <h3>Basic datatable</h3>
  <div class="row my-large align-items-end">
    <div class="col">
      <label class="form-label" for="tableType">Table style</label>
      <select id="tableType" class="form-select" [(ngModel)]="tableType">
        <option value>Default style</option>
        <option value="spaced-cells">
          Spaced cells - for easier reading of a table with many columns
        </option>
        <option value="striped-rows">
          Striped lines - for easier reading of a table of 10 or more rows
        </option>
        <option value="inverted-colors">Inverted colors - to use on a colored background</option>
        <option value="lines-separated-rows">
          Lines-separated rows - for use in content pages
        </option>
      </select>
    </div>
    <div class="col offset-1">
      <div class="form-check">
        <input
          [(ngModel)]="headerColumn"
          class="form-check-input"
          type="checkbox"
          value=""
          id="headerColumn"
        />
        <label class="form-check-label" for="headerColumn">
          Make the first column a header column
        </label>
      </div>
    </div>
  </div>
  <div [ngClass]="{ 'bg-light p-regular': tableType === 'inverted-colors' }">
    <app-datatable-demo [tableType]="tableType" [headerColumn]="headerColumn"></app-datatable-demo>
  </div>
  <p class="h5 bold mt-4">datatable-demo.component.html</p>
  <code class="block" [highlight]="basicTemplate" [languages]="['html']"></code>
  <p class="h5 bold mt-4">datatable-demo.component.ts</p>
  <code class="block" [highlight]="basicComponent" [languages]="['typescript']"></code>
</section>

<hr />

<section>
  <h3>Paginated datatable</h3>
  <div class="my-large w-25">
    <label class="form-label" for="paginationMode">Pagination mode</label>
    <select class="form-select" id="paginationMode" [(ngModel)]="paginationMode">
      <option value="standard">Standard pagination</option>
      <option value="loader">Pagination with a loader</option>
    </select>
  </div>
  <app-datatable-paginated-demo [paginationMode]="paginationMode"></app-datatable-paginated-demo>
  <p class="h5 bold mt-4">datatable-paginated-demo.component.html</p>
  <code class="block" [highlight]="paginationTemplate" [languages]="['html']"></code>
</section>

<hr />

<section>
  <h3>Editable datatable</h3>
  <app-datatable-editable-demo></app-datatable-editable-demo>
  <p class="h5 bold mt-4">datatable-editable-demo.component.html</p>
  <code class="block" [highlight]="editionTemplate" [languages]="['html']"></code>
</section>

<section>
  <h3>Datatable with loading indicator</h3>
  <app-datatable-loading-demo></app-datatable-loading-demo>
  <p class="h5 bold mt-4">datatable-loading-demo.component.html</p>
  <code class="block" [highlight]="loadingTemplate" [languages]="['html']"></code>
</section>
